import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { IDtoShipmentReturnCode } from '../interfaces/dto.shipment.return.code.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoShipmentReturnCode')
export class DtoShipmentReturnCode extends ModelEntity implements IDtoShipmentReturnCode {

    constructor(initValues: Partial<IDtoShipmentReturnCode> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('text', String, true)
    public text?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    public get fullDescription(): string {
        return UtilsString.stringFormat('{0} - {1}', this.code, this.description).trim();
    }

}
